<template>
  <div>
    <b-container>
      <b-row>
        <b-col class="p-0">
          <p class="text-justify mt-3">
            {{ $t("depending_of_how_big_the_report_is") | capitalize }}.
            <br>
            {{ $t("we_will_send_you_an_email_with_a_link") | capitalize }}.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="p-0">
          <b-form-group :label="$t('email') | capitalize">
            <b-form-input v-model="email"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
    <b-row class="modal-footer mt-4">
      <b-button class="btn-outline-dark" @click="cancel">
        {{ $t("cancel") | capitalize }}
      </b-button>
      <b-button :disabled="!isValid" class="btn-outline-red" @click="exportData" id="submit-export-btn">
        {{ $t("export") | capitalize }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import {
  transactionAggregations,
  xlsxMaxCount
} from "@/constants"

export default {
  name: "TransactionsExportForm",
  props: {
    count: {
      required: true,
      type: Number
    }
  },
  computed: {
    ...mapState("user", ["user"]),
    isValid () {
      return this.email
    },
    query () {
      const query = { ...this.$route.query }
      delete query.page
      delete query.limit
      query.apply_precision = false

      if (Array.isArray(query.tariff_period_year)) {
        query.tariff_period_year.forEach((year, index) => {
          const yearNumber = Number(year)
          if (!isNaN(yearNumber) && index === 0) {
            query.distribution_period_start__gte = `${yearNumber}-01-01`
          } else {
            query.distribution_period_end__lt = `${yearNumber + 1}-01-01`
          }
        })
      }

      query.aggregate_by = transactionAggregations[query.aggregate_by] || transactionAggregations.none
      if (query["total_playcount_min"]) {
        query["total_playcount__gte"] = query["total_playcount_min"]
      }
      if (query["total_playcount_max"]) {
        query["total_playcount__lte"] = query["total_playcount_max"]
      }

      // replace transactions specific payout filters with actual filter queries
      if (query.transaction_transaction_batch_id) {
        query.transaction_batch_id = query.transaction_transaction_batch_id
        delete query.transaction_transaction_batch_id
      }
      if (query.transaction_payout_completed_id) {
        query.payout_completed_id = query.transaction_payout_completed_id
        delete query.transaction_payout_completed_id
      }

      return query
    },
    xlsxAvailable () {
      return this.count < xlsxMaxCount
    },
  },
  data () {
    return {
      email: null,
    }
  },
  methods: {
    ...mapMutations("alert", ["success", "error"]),
    exportData () {
      let data = {
        email: this.email,
        query: this.query,
        user_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }
      this.$api.transactions.exportTransactions(data)
        .then(response => {
          let msg = `Transactions export started: ${response.statusText}`
          this.success(msg)
          this.$bvModal.hide("transactions-export-modal")
        })
        .catch(error => {
          let msg = `Export error: ${JSON.stringify(error.response.data)}`
          this.error(msg)
        })
    },
    cancel () {
      this.$bvModal.hide("transactions-export-modal")
    },
  },
  mounted () {
    this.email = this.user.email
  },
}
</script>
